module.exports = __webpack_public_path__ + "img/images_homebanner_3_2.00a3f6d4.png";